import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DirectivesModule } from '@app/@core/directives/directives.module';
import { MaterialUIModule } from '@app/shared/modules/material-ui/material-ui.module';
import { SharedPipesModule } from '@core/pipes/shared-pipes.module';
import { DxDataGridModule } from 'devextreme-angular';
import { NgxMaskModule } from 'ngx-mask';
import { NgxPaginationModule } from 'ngx-pagination';
import { NgxfUploaderModule } from 'ngxf-uploader';
import { GridYouthListComponent } from './app-grid-youth-list.component';

@NgModule({
  declarations: [GridYouthListComponent],
  imports: [
    CommonModule,
    MaterialUIModule,
    NgxPaginationModule,
    DxDataGridModule,
    SharedPipesModule,
    FormsModule,
    ReactiveFormsModule,
    DirectivesModule,
    NgxfUploaderModule,
    NgxMaskModule.forRoot()
  ],
  exports: [GridYouthListComponent],
})
export class GridYouthListModule {}
